import { ChangeEvent } from 'react';

import { useTranslation } from '@mint-lib/i18n';

import {
  Box,
  SearchBar,
  SelectWithSearch,
  ToggleButton,
  ToggleButtonGroup,
  type OptionType,
} from '@myn/mui';

import { VersionView } from '../../types/versions.js';

export type Props = {
  searchValue: string;
  onSearchChange: (value: string) => void;
  versionOptions: OptionType[];
  selectedVersions: number[];
  onSelectVersion: (options: number[]) => void;
  onClickVersionView: (view: VersionView) => void;
  currentView: VersionView;
};

const VersionsHeader = ({
  searchValue,
  onSearchChange,
  versionOptions,
  selectedVersions,
  onSelectVersion,
  onClickVersionView,
  currentView,
}: Props) => {
  const { t } = useTranslation('@myn/planning');

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    onSearchChange(event.target.value);
  };

  const handleSearchClear = () => {
    onSearchChange('');
  };

  const handleClickTableView = () => {
    onClickVersionView(VersionView.Table);
  };

  const handleClickMixView = () => {
    onClickVersionView(VersionView.Mix);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
        marginBottom: 3,
      }}
    >
      <Box
        sx={{
          flex: 1,
          maxWidth: 400,
        }}
      >
        <SearchBar
          aria-label="Search"
          fullWidth
          placeholder={t('Search')}
          value={searchValue}
          onChange={handleSearchChange}
          onClear={handleSearchClear}
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <SelectWithSearch
          multiple
          value={selectedVersions}
          options={versionOptions}
          onChange={onSelectVersion}
        />
        <ToggleButtonGroup value={currentView} size="large">
          <ToggleButton
            icon="ChartPie"
            value={VersionView.Mix}
            onClick={handleClickMixView}
          />
          <ToggleButton
            icon="Table"
            value={VersionView.Table}
            onClick={handleClickTableView}
          />
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
};

export default VersionsHeader;
